import { CourseConfig } from "../models/teeBox";
import { CourseDetailsForHandicap, MslValues } from "../models/leagueInterfaces";

export const convertToHandicapDetails = (config: CourseConfig): CourseDetailsForHandicap => {
  const courseRating: MslValues = {
    M: config.tees.men.courseRating,
    S: config.tees.seniors.courseRating,
    L: config.tees.ladies.courseRating
  };

  const slopeRating: MslValues = {
    M: config.tees.men.slopeIndex,
    S: config.tees.seniors.slopeIndex,
    L: config.tees.ladies.slopeIndex
  };

  const coursePar = config.holes.reduce((total, hole) => total + hole.par, 0);

  return {
    id: config.id,
    courseName: config.courseName,
    courseRating,
    slopeRating,
    courseTee: `${config.tees.men.color}/${config.tees.seniors.color}/${config.tees.ladies.color}`,
    coursePar
  };
};
